<app-preview-listing [pageLoad]="trueCount ? false : true" [listingId]="listing_preview_id"></app-preview-listing>
